import { mergeClasses } from "../lib/mergeClasses";

const bubbles = Array.from({ length: 3 }).map((_, i) => i)

type ThinkingBubblesProps = {
  className?: string;
}
const ThinkingBubbles = ({ className = "" }: ThinkingBubblesProps) => {
  return (
    <>
      <div
        className={mergeClasses(`px-4 py-2 rounded-xl text-sm max-w-[70%] bg-white text-black flex items-end justify-start gap-1`, className)}
      >
        {
          bubbles.map((idx) => (
            <span
              className="block !w-2 !h-2 !min-w-2 !min-h-2 rounded-full bg-[var(--sonaris-color-primary)] transition-all"
              style={{
                animationName: 'thinking',
                animationDuration: `${(bubbles.length + 1) * 0.25}s`,
                animationDelay: `${idx * 0.25}s`,
                animationIterationCount: 'infinite',
              }}
            ></span>
          ))
        }
      </div>

      <style>
        {`
          @keyframes thinking {
            0% { transform: translateY(0%); }
            40% { transform: translateY(-75%); }
            80% { transform: translateY(0%); }
          }
        `}
      </style>
    </>
  )
}

export default ThinkingBubbles
